import React, { useState } from 'react'
import { css } from '@emotion/core'
import { Button } from '@/components/atoms/button'

type ResolveHandler = (isConfirmed: boolean) => void

export const useDiscountReceivableTargetChangeConfirmDialog = () => {
  const [isShowDialog, setIsShowDialog] = useState(false)
  const [resolveHandler, setResolveHandler] = useState<ResolveHandler>()

  const openConfirmDialog = (): Promise<boolean> => {
    setIsShowDialog(true)
    return new Promise(resolve => setResolveHandler(() => resolve))
  }

  const onClose = (isConfirmed: boolean) => {
    setIsShowDialog(false)
    if (resolveHandler) {
      resolveHandler(isConfirmed)
      setResolveHandler(undefined)
    }
  }

  const DiscountReceivableTargetChangeConfirmDialog: React.FC = () =>
    isShowDialog ? (
      <>
        <div css={modalBackgroundStyle}></div>
        <div css={modalStyle}>
          <div className="text-area">
            <p>以下の変更が売掛金管理に反映されます。保存しますか？</p>
            <p>
              ・売掛対象外から売掛対象：売掛金一覧・売掛金残高に表示され、売掛金の計算開始月以降（最大6ヶ月）の対象売掛先の売掛金が新たに表示されます。{' '}
            </p>
            <p>・売掛対象から売掛対象外：入金(消込)履歴は表示されますが、売掛金一覧・売掛金残高では非表示になります。</p>
          </div>
          <div className="button-area">
            <Button width={110} height={38} buttonType={3} fontSize={12} onClick={() => onClose(false)}>
              キャンセル
            </Button>
            <Button width={110} height={38} buttonType={1} fontSize={12} onClick={() => onClose(true)}>
              保存
            </Button>
          </div>
        </div>
      </>
    ) : (
      <></>
    )

  return {
    openConfirmDialog,
    DiscountReceivableTargetChangeConfirmDialog,
  }
}

const modalStyle = css({
  minHeight: 220,
  width: 560,
  position: 'fixed',
  zIndex: 1000,
  background: '#FFFFFF',
  left: 'calc(-50vw + 100% - 560px / 2)',
  padding: '24px 32px',
  borderRadius: 5,
  '.text-area': {
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: 16,
    letterSpacing: 0.6,
    lineHeight: '24px',
    p: {
      margin: 0,
    },
    'p + p': {
      marginTop: 16,
      paddingLeft: '1em',
      textIndent: '-1em',
    },
  },
  '.button-area': {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    paddingTop: 24,
  },
})

const modalBackgroundStyle = css({
  background: '#272727',
  width: '100vw',
  height: '100vh',
  position: 'fixed',
  zIndex: 999,
  top: 0,
  left: 0,
  opacity: 0.5,
})
